<template>
  <div>
    <section class="container section is-main-section fullwidthmainsection">
      <form @submit.prevent="save">
        <div>
          <v-card-component title="Add New Vendor / Vehicle Details ">
            <v-card-actions>
              <router-link :to="{ name: 'Vendor' }">
                <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
                  <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity: 0.6">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
            <v-container class="fullwidthmainsection">
              <v-card class="vendarodetailsborder">
                <v-card-title>Section A: Vendor Details</v-card-title>
                <v-card-text>
                    <v-row>
                      <v-col>
                        <v-row>
                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium" >1.Select Franchise</span>
                            <span class="error--text ml-1">*</span>:
                            <v-autocomplete v-model="formData.franchiseeID" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium" >2.Owned By</span>
                            <span class="error--text ml-1">*</span>:
                            <v-autocomplete v-model="formData.ownedBy" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="VehicleTypes" item-text="name" item-value="value">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium">3.Owner Name</span>
                            <span class="error--text ml-1">*</span>:
                            <v-text-field v-model.trim="formData.ownerName" required class="my-0 py-1" maxlength="100">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium">4.Owner's Mobile No.</span>
                            <span class="error--text ml-1">*</span>:
                            <v-text-field
                              prefix="+91"
                              v-model="formData.ownersMobileNumber"
                              required
                              class="my-0 py-1 mobile-field"
                              type="number"
                              onKeyPress="if(this.value.length==10) return false;"
                              :class="{ 'no-spinner': true }"
                              placeholder="Enter 10-digit mobile number"
                              :disabled="isMobileNoVerified"
                            >
                              <template v-slot:append>
                                <v-btn
                                v-if="!isMobileNoVerified && formData?.ownersMobileNumber?.length === 10"
                                  icon
                                  color="primary"
                                  class="ml-2 mr-2 verify-cta"
                                  @click="verifyOtp('owner','up')"
                                >
                                  verify
                                </v-btn>
                                <v-icon color="#00ff00" v-if="isMobileNoVerified">mdi-check-decagram-outline</v-icon>
                              </template>
                            </v-text-field>

                          </v-col>
                          <v-dialog v-model="showVerification" max-width="350" >
                          <v-card >
                            <v-card-title>
                              <h3 class="text-h6">OTP Verification: <span class="font-weight-black text-primary">{{ formData.ownersMobileNumber }}</span></h3>
                            </v-card-title>
                            <v-card-actions style="display: inline-flex; flex-direction: column;">
                              <v-otp-input
                                v-model="otp"
                                class="mt-3"
                                length="4"
                                type="number"
                                placeholder="0"
                                variant="underlined"
                              ></v-otp-input>
                              <v-divider class="mt-3 mb-6"></v-divider>
                              <div v-if="isTimerEnded" class="mb-3 text-body-2">
                                Didn't get <strong>OTP</strong>?
                                <a href="#" @click.prevent="verifyOtp('ownerResend')">Resend</a>
                              </div>
                              <div v-else-if="this.timer===60" class="mb-3 text-body-2">Resend OTP in 01:00 </div>
                              <div v-else-if="this.timer>=10" class="mb-3 text-body-2">Resend OTP in 00:{{ timer }} </div>
                              <div v-else class="mb-3 text-body-2">Resend OTP in 00:0{{ timer }} </div>
                              <v-btn
                                class="my-4"
                                color="green"
                                height="40"
                                variant="flat"
                                width="70%"
                                :disabled="otp.length !== 4"
                                @click="verifyOtp('owner')"
                              >Verify</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium">5.Number of Vehicles</span>
                            <span class="error--text ml-1">*</span>:
                            <v-text-field readonly :disabled="true" v-model="formData.numberOfVehicle" required class="my-0 py-1" type="number" min="1"  @keypress="preventInvalidInput" @keydown="(e) => handleBackspace(e, formData.numberOfVehicle)">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" lg="4" sm="6">
                            <span class="body-2 font-weight-medium">6.Number of Drivers</span>
                            <span class="error--text ml-1">*</span>:
                            <v-text-field readonly :disabled="true" v-model="formData.numberOfDrivers" required class="my-0 py-1" type="number" min="1" @keypress="preventInvalidInput" @keydown="(e) => handleBackspace(e, formData.numberOfDrivers)">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
              </v-card>
            </v-container>
            <v-container class="fullwidthmainsection">
              <v-expansion-panels v-model="panel" single-line>
                <v-expansion-panel :value="0" :disabled="!validVendorDetails()" class="my-4">
                  <v-expansion-panel-header :class="validVendorDetails() ? 'blue-header' : 'light-blue-header'"  @click="handleVehicleHeaderClick">
                    Section B. Add Vehicle Details
                    <span class="error--text ml-1">*</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="vendarodetailsborderpadd" v-if="hasShownVehicleConfirmDialog">
                    <v-container class="fullwidthmainsection">
                      <v-card class="vendarodetailsborder02"
                        v-for="(bus, index) in formData.buses" :key="index"
                        >
                      <v-toolbar flat>
                          <v-toolbar-title class="text-h6">{{ `Section B.${index + 1}. Vehicle ${index + 1}` }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn
                          v-if="formData.numberOfVehicle > 1"
                          icon @click="handleRemoveVehicleCard(index)">
                          <v-icon>mdi-close</v-icon>
                          </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <div class="mt-2">
                        <!-- <v-chip>Bus - {{ index + 1 }}</v-chip> -->
                        <v-row>
                          <v-col>
                            <v-row>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">1.Vehicle Registration No.</span>
                                <span class="error--text ml-1">*</span>:
                                <v-text-field
                                  v-model.trim="formData.buses[index].vehicleRegistrationNumber"
                                  required
                                  class="my-0 py-1"
                                  @input="handleVehicleNumberInput($event, index)"
                                  @keydown="handleVehicleNumberKeydown($event, index)"
                                  @paste="handleVehicleNumberPaste($event, index)"
                                  :rules="[rules.patternRule]"
                                  :error-messages="formData.buses[index].vehicleValidationError"
                                  :maxlength="13"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium" >2.Seating Capacity</span>
                                <span class="error--text ml-1">*</span>:
                                <small class="text-muted">(This is excluding Driver & Bus Attendant)</small>

                                <v-text-field v-model="bus.seatingCapacity" required class="my-0 py-1" type="number" min="0"  @focus="setFocusedInput($event, index)" ></v-text-field>
                              </v-col>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">3.Make of the Vehicle</span>
                                <span class="error--text ml-1">*</span>:
                                <v-text-field v-model.trim="bus.makeOfVehicle" required class="my-0 py-1" @focus="setFocusedInput($event, index)" ></v-text-field>
                              </v-col>

                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-row>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">4.Model of the Vehicle</span>
                                <span class="error--text ml-1">*</span>:
                                <v-text-field v-model.trim="bus.modelOfVehicle" required class="my-0 py-1" @focus="setFocusedInput($event, index)" ></v-text-field>
                              </v-col>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">5.RC Expiry Date</span>
                                <span class="error--text ml-1">*</span>:
                                <custom-date-picker
                                :minToDate="minDate"
                                v-model="bus.rcBookExpiryDate"
                                @input="handleValidateExpiryDate($event,'RC', 'buses', 'rcBookExpiryDate', index)"
                                />
                              </v-col>
                              <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">6.PUC Expiry Date</span>
                                <span class="error--text ml-1">*</span>:
                                <custom-date-picker
                                v-model="bus.pucExpiryDate"
                                :minToDate="minDate"
                                @input="handleValidateExpiryDate($event,'PUC','buses','pucExpiryDate',index)"
                                />
                              </v-col>
                                <v-col cols="12" lg="4" sm="6">
                                <span class="body-2 font-weight-medium">7. Add trips number, (per pickup/drop)</span>
                                <span class="error--text ml-1">*</span>:
                                <br/>
                                <small class="text-caption grey--text">
                                Enter how many times this bus will run for a single pickup/drop.
                                This may be due to seat capacity (e.g., 7 students, 4 seats → 2 trips)
                                or multiple school batches (e.g., 9 AM–12 PM & 12 PM–3 PM sessions → 2 trips).
                              </small>
                                <v-text-field
                                  v-model.number="bus.tripsPerBus"
                                  type="number"
                                  :rules="[validateTrips]"
                                  @keydown="preventInvalidInput"
                                  :data-index="index"
                                />
                                <div v-if="bus.tripsError" class="error--text">Enter a number less than or equal to 5</div>
                                <div class="body-2 font-italic">Max trips handled is 5</div>
                            </v-col>

                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <div class="heading-container mb-2">
                              <h1 class="left-heading">Upload the following documents:</h1>
                              <u><h1 class="right-heading"><strong>Formats: </strong>png,jpg,jpeg,heic,heif allowed <br/><strong>Size: </strong> upto 2MB</h1></u>
                            </div>
                            <v-row>
                              <v-col
                                cols="12"
                                md="4"
                                lg="4"
                                v-for="(field, index) in fileFields"
                                :key="field.field"
                              >
                                <!-- File Upload Section -->
                                <v-card outlined>
                                  <v-toolbar flat>
                                    <v-toolbar-title class="mr-4">
                                      <label class="label mb-2">
                                        {{ field.label }}<span class="error--text ml-1">*</span>:
                                      </label>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon small class="ml-auto" @click="deleteDropFile(bus, field.field)">
                                      <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                  </v-toolbar>
                                  <b-field class="file is-primary mb-3 ml-3">
                                    <b-upload
                                      @input="onFileChange(bus, field.field, 'fileFields', index)"
                                      class="file-label"
                                      accept="image/*"
                                    >
                                      <span class="file-cta">
                                        <b-icon class="file-icon" icon="upload"></b-icon>
                                        <span class="file-label">Click to upload</span>
                                      </span>
                                    </b-upload>
                                  </b-field>

                                  <!-- Image Preview Section -->
                                  <div v-if="bus[`${field.field.replace('Photo','PhotoUrl')}`]" class="mt-2 relative-position carduploadviewnone">
                                    <v-img
                                      :src="bus[`${field.field.replace('Photo','PhotoUrl')}`]"
                                      class="align-center"
                                      height="200px"
                                    >
                                    </v-img>
                                  </div>
                                </v-card>
                              </v-col>

                            </v-row>
                            <!-- <div class="d-flex justify-end">
                              <v-btn style="color: #fff" class="mt-3" color="#40c057" size="small" variant="flat" :disabled="bus.shouldDraftButtonDisable && bus.isFormDrafted && isBusFormAllFilled(index) && focusedBus !== index">Save Details</v-btn>
                            </div> -->
                            <v-row class="px-1">
                              <v-col cols="6" lg="4" sm="6">
                              <!-- <v-checkbox v-model="bus.isCCTVInstalled" label="15.Is CCTV Installed and is Working?"><span class="error--text ml-1">*</span>:</v-checkbox> -->
                                <span>16.Is CCTV Installed and is Working?</span><span class="error--text ml-1">*</span>
                                <v-radio-group
                                  v-model="bus.isCCTVInstalled"
                                  row
                                  class="mt-2"
                                >
                                  <v-radio label="Yes" value="yes"></v-radio>
                                  <v-radio label="No" value="no"></v-radio>
                                </v-radio-group>

                              </v-col>

                            <!-- GPS installed and working -->
                              <v-col cols="16" lg="4" sm="6">
                                <span>17. Is GPS installed and working?</span>
                                <span class="error--text ml-1">*</span>:
                                <v-radio-group
                                  v-model="bus.gpsWorking"
                                  row
                                  class="mt-2"
                                >
                                  <v-radio label="Yes" value="yes"></v-radio>
                                  <v-radio label="No" value="no"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                            <!-- <div class="d-flex justify-end">
                              <v-btn style="color: #fff" class="mt-3" color="#40c057" size="small" variant="flat" @click="draftBusDetails(index)">Save Details</v-btn>
                            </div> -->
                          </v-col>
                        </v-row>
                      </div>
                      </v-card-text>

                    </v-card>
                    <v-spacer></v-spacer>
                    <div class="d-flex justify-end mx-3">
                              <v-btn style="color: #fff" class="mt-3" color="#40c057" size="small" variant="flat" @click="increaseVehicleCount">Add More Vehicles</v-btn>
                    </div>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
               <v-spacer></v-spacer>
                <v-expansion-panel :value="1" :disabled="!validVehicleDetails()" class="my-4" >
                  <v-expansion-panel-header :class="validVehicleDetails() ? 'blue-header' : 'light-blue-header'">
                    Section C. Add Driver Details
                    <span class="error--text ml-1">*</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="vendarodetailsborderpadd">
                    <v-container class="fullwidthmainsection">
                      <v-card class="vendarodetailsborder02"
                      v-for="(driver, index) in formData.drivers" :key="index"
                      >
                    <v-toolbar flat>
                        <v-toolbar-title class="text-h6">{{ `Section C.${index + 1}. Driver ${index + 1}` }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                         v-if="formData.numberOfDrivers > 1"
                         icon @click="handleRemoveDriverCard(index)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <div class="mt-2">
                      <!-- <v-chip>Bus - {{ index + 1 }}</v-chip> -->
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="12" lg="4" sm="6">
                              <span class="body-2 font-weight-medium">1.Driver Name </span>
                              <v-text-field v-model.trim="driver.driverName" required class="my-0 py-1" ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="4" sm="6">
                              <span class="body-2 font-weight-medium">2.Driver Mobile No.</span>
                              <span class="error--text ml-1">*</span>:
                              <v-text-field
                                prefix="+91"
                                v-model="driver.driverMobileNumber"
                                :disabled="driver.isMobileNoVerifiedDriver"
                                required class="my-0 py-1" type="number"
                                onKeyPress="if(this.value.length==10) return false;"
                                :class="{ 'no-spinner': true, 'mobile-field': true }"
                                placeholder="Enter 10-digit mobile number"
                              >
                                <template v-slot:append>
                                  <v-btn
                                  v-if="!driver.isMobileNoVerifiedDriver && driver?.driverMobileNumber?.length === 10"
                                    icon
                                    class="ml-2 mr-2 verify-cta"
                                    color="primary"
                                    @click="verifyOtp('driver', driver, index, 'up')"
                                  >
                                  verify
                                  </v-btn>
                                  <v-icon color="#00ff00" v-if="driver.isMobileNoVerifiedDriver">mdi-check-decagram-outline</v-icon>

                                </template>
                              </v-text-field>
                            </v-col>

                            <v-dialog v-model="driver.showVerificationDriver" max-width="350" >
                            <v-card >
                              <v-card-title>
                                <h3 class="text-h6">OTP Verification: <span class="font-weight-black text-primary">{{ driver.driverMobileNumber }}</span></h3>
                              </v-card-title>
                              <v-card-actions style="display: inline-flex; flex-direction: column;">
                                <v-otp-input
                                  v-model="otp"
                                  class="mt-3"
                                  length="4"
                                  type="number"
                                  placeholder="0"
                                  variant="underlined"
                                ></v-otp-input>
                                <v-divider class="mt-3 mb-6"></v-divider>
                                <div v-if="isTimerEnded" class="mb-3 text-body-2">
                                  Didn't get <strong>OTP</strong>?
                                  <a href="#" @click.prevent="verifyOtp('driverResend', driver, index)">Resend</a>
                                </div>
                                <div v-else-if="timer===60" class="mb-3 text-body-2">Resend OTP in 01:00 </div>
                                <div v-else-if="timer>=10" class="mb-3 text-body-2">Resend OTP in 00:{{ timer }} </div>
                                <div v-else class="mb-3 text-body-2">Resend OTP in 00:0{{ timer }} </div>
                                <v-btn
                                  class="my-4"
                                  color="green"
                                  height="40"
                                  variant="flat"
                                  width="70%"
                                  :disabled="otp.length !== 4"
                                  @click="verifyOtp('driver', driver, index)"
                                >Verify</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            <v-col cols="12" lg="4" sm="6">
                              <span class="body-2 font-weight-medium">3.Driver License No.</span>
                              <span class="error--text ml-1">*</span>:
                              <v-text-field v-model.trim="driver.driverLicenseNumber" required class="my-0 py-1" ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="12" lg="4" sm="6">
                              <span class="body-2 font-weight-medium">4.Unique Identification No.</span>
                              <span class="error--text ml-1">*</span>:
                              <v-text-field
                                :rules="[rules.uidNoRule]"
                                v-model.trim="driver.uniqueIdentificationNumber"
                                required
                                class="my-0 py-1"
                                :class="{ 'no-spinner': true }"
                                type="number"
                                onKeyPress="if(this.value.length===12) return false"

                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="4" sm="6">
                              <span class="body-2 font-weight-medium">5.License Expiry Date</span>
                              <span class="error--text ml-1">*</span>:
                              <custom-date-picker
                              :minToDate="minDate"
                              v-model="driver.licenceExpiryDate"
                              @input="handleValidateExpiryDate($event, 'License', 'drivers', 'licenceExpiryDate',index)"
                              />
                            </v-col>

                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <div class="heading-container mb-2">
                              <h1 class="left-heading">Upload the following documents:</h1>
                              <u><h1 class="right-heading"><strong>Formats: </strong>png,jpg,jpeg,heic,heif allowed<br/><strong>Size: </strong> upto 2MB</h1></u>
                          </div>
                          <v-row>
                            <v-col cols="3" md="4" lg="4" sm="4" v-for="(field, index) in driverfileFields" :key="field.field">
                              <v-card class="p-2 carduploadview">
                                <v-toolbar flat>
                                    <v-toolbar-title class="mr-4">
                                      <label class="label mb-2">
                                        <label class="label">{{ field.label }}<span class="error--text ml-1">*</span>:</label>
                                      </label>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon small class="ml-auto"  @click="deleteDropFile(driver, field.field)">
                                      <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                  </v-toolbar>
                              <b-field class="file is-primary">
                                <b-upload  @input="onFileChange(driver, field.field,'driverfileFields', index)" class="file-label" accept="image/*">
                                  <span class="file-cta">
                                    <b-icon class="file-icon" icon="upload"></b-icon>
                                    <span class="file-label">Click to upload</span>
                                  </span>
                                </b-upload>
                              </b-field>

                              <div class="mt-2 relative-position carduploadviewnone" v-if="driver[`${field.field.replace('Photo','PhotoUrl')}`]">

                                  <v-img
                                    :src="driver[`${field.field.replace('Photo','PhotoUrl')}`]"
                                    class="align-end"
                                    height="200px"
                                  >
                                  </v-img>

                            </div>
                            </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                    </v-card-text>
                    <!-- <div class="text-right">
                      <button class="button is-success" :disabled="!validateForm()" type="submit" style="margin-top: 20px">
                        save
                      </button>
                    </div> -->
                  </v-card>
                  <v-spacer></v-spacer>
                  <div class="d-flex justify-end mx-3">
                       <v-btn style="color: #fff" class="mt-3" color="#40c057" size="small" variant="flat" @click="increaseDriversCount">Add More Drivers</v-btn>
                  </div>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
            </v-container>
             <div class="d-flex justify-end">
              <button class="button is-primary"  type="submit" :disabled="!validateForm()"  style="margin-top: 20px;min-width:300px;" >
               Save
              </button>
              <button class="button is-danger" @click="handleCancelForm()" type="button" style="margin-top: 20px;margin-left: 20px;min-width:300px;" >
               Cancel
              </button>
            </div>
          </v-card-component>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePickerr'
import Utils from '@/utils'
import moment from 'moment'
export default {
  name: 'VendorAdd',
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      panel: [],
      fileUpload: null,
      showConfirmDialogBox: true,
      hasShownVehicleConfirmDialog: false,
      hasShowDriverConfirmDialog: false,
      verifiedFlag: false,
      interval: null,
      referenceId: '',
      isTimerEnded: false,
      timer: 60,
      otp: '',
      showVerification: false,
      isExpanded: false,
      total: 0,
      dropFile: [],
      isVendorDetailsPresent: false,
      isVehicleDetailsPresent: false,
      isMobileNoVerified: false,
      isMobileNoVerifiedDriver: [],
      franchiseeID: '',
      vtsActivation: 1,
      batteryNo: '',
      MakeOfvehicle: '',
      RCBookNo: '',
      RCExpirydate: '',
      RCStartdate: '',
      ChasisNo: '',
      engineNumber: '',
      rentCost: 0,
      MakeOfthevehicle: '',
      seatingCapacity: '',
      Purchasedate: '',
      ModelOfvehicle: '',
      isReadOnly: true,
      registrationNo: '',
      franchiseeArr: [],
      isRequired: false,
      vehicleType: 'School Owned',
      selectedFranchisee: [],
      academicYears: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      vtsactivations: [{ id: 1, name: 'YES' }],
      minDate: moment().format('YYYY-MM-DD'),
      VehicleTypes: [
        { id: 1, name: 'School Owned', value: 'School-Owned' },
        { id: 2, name: 'School Leased', value: 'School-Leased' },
        { id: 3, name: 'Vendor Owned', value: 'Vendor-Owned' }
      ],
      allowedExtensions: ['image/jpg', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'],
      maxFileSize: 1024 * 1024 * 2,
      fileRules: [
        file => !file || this.allowedExtensions.includes(file.type) || 'Allowed file types are jpg, jpeg, png, heic, heif.',
        file => !file || file.size <= this.maxFileSize || 'File size should not exceed 2 MB.'
      ],
      formData: {
        franchiseeID: null,
        ownedBy: null,
        ownerName: null,
        ownersMobileNumber: null,
        numberOfVehicle: 1,
        numberOfDrivers: 1,
        buses: [{
          isCCTVInstalled: false,
          gpsWorking: null,
          vehicleRegistrationNumber: '',
          seatingCapacity: '',
          makeOfVehicle: '',
          modelOfVehicle: '',
          rcBookExpiryDate: '',
          pucExpiryDate: '',
          tripsPerBus: null,
          rcBookFrontPhoto: null,
          rcBookBackPhoto: null,
          pucFrontPhoto: null,
          vehicleFrontViewPhoto: null,
          vehicleRearViewPhoto: null,
          vehicleInteriorViewPhoto: null,
          vehicleInteriorLeftViewPhoto: null,
          vehicleInteriorRightViewPhoto: null,
          rcBookFrontPhotoUrl: null,
          rcBookBackPhotoUrl: null,
          pucFrontPhotoUrl: null,
          vehicleFrontViewPhotoUrl: null,
          vehicleRearViewPhotoUrl: null,
          vehicleInteriorViewPhotoUrl: null,
          vehicleInteriorLeftViewPhotoUrl: null,
          vehicleInteriorRightViewPhotoUrl: null,
          vehicleValidationError: []
        }],
        drivers: [{
          showVerificationDriver: false,
          isMobileNoVerifiedDriver: false,
          driverName: '',
          driverMobileNumber: '',
          driverLicenseNumber: '',
          uniqueIdentificationNumber: '',
          licenceExpiryDate: '',
          driverLicenseFrontPhoto: null,
          driverPhoto: null,
          driverPoliceVerificationPhoto: null,
          driverLicenseFrontPhotoUrl: null,
          driverPhotoUrl: null,
          driverPoliceVerificationPhotoUrl: null
        }]
      },
      fileFields: [
        { field: 'rcBookFrontPhoto', label: '8.RC Card Front' },
        { field: 'rcBookBackPhoto', label: '9.RC Card Back' },
        { field: 'pucFrontPhoto', label: '10.PUC Front View' },
        { field: 'vehicleFrontViewPhoto', label: '11.Vehicle Front View' },
        { field: 'vehicleRearViewPhoto', label: '12.Vehicle Rear View' },
        { field: 'vehicleInteriorViewPhoto', label: '13.Vehicle Interior View' },
        { field: 'vehicleInteriorLeftViewPhoto', label: '14.Vehicle Interior Left View' },
        { field: 'vehicleInteriorRightViewPhoto', label: '15.Vehicle Interior Right View' }
      ],
      driverfileFields: [
        { field: 'driverLicenseFrontPhoto', label: '6.Driver License Front' },
        { field: 'driverPhoto', label: '7.Driver Photo' },
        { field: 'driverPoliceVerificationPhoto', label: `8.Driver's Police Verification Photo` }
      ],
      fileKeys: ['rcBookFrontPhoto', 'rcBookBackPhoto', 'pucFrontPhoto', 'vehicleFrontViewPhoto', 'vehicleRearViewPhoto', 'vehicleInteriorViewPhoto', 'vehicleInteriorLeftViewPhoto', 'vehicleInteriorRightViewPhoto', 'driverLicenseFrontPhoto', 'driverPhoto', 'driverPoliceVerificationPhoto'],
      documentFileKeys: {
        vehicle: ['rcBookFrontPhoto', 'rcBookBackPhoto', 'pucFrontPhoto', 'vehicleFrontViewPhoto', 'vehicleRearViewPhoto', 'vehicleInteriorViewPhoto', 'vehicleInteriorLeftViewPhoto', 'vehicleInteriorRightViewPhoto'],
        driver: ['driverLicenseFrontPhoto', 'driverPhoto', 'driverPoliceVerificationPhoto']
      },
      focusedBus: null,
      imageUrls: {
        vehicles: [],
        drivers: []
      },
      rules: {
        uidNoRule: v => v.length === 12 || 'Please enter exactly 12 digits',
        noValid: v => {
          if (!/^\d+$/.test(v)) {
            return false
          }

          if (parseInt(v, 10) <= 0) {
            return false
          }
          return true
        },
        patternRule: v => {
          if (!v) return 'Enter a valid vehicle registration number'
          // Last part must be exactly 4 digits
          const pattern = /^[A-Z]{2}-\d{1,2}-[A-Z]{1,2}-\d{4}$/
          return pattern.test(v) ||
                'Please enter a valid vehicle number (e.g., MH-09-GT-8486 or CG-22-W-6000)'
        }
      }
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
    this.loadDraft()
  },
  watch: {
    'formData.numberOfVehicle': function (newVal, oldVal) {
      if (newVal === '0' || newVal === null || newVal === '') {
        this.panel = []
      }
      this.addBusForms()
    },
    'formData.numberOfDrivers': function (newVal, oldVal) {
      if (newVal === '0' || newVal === null || newVal === '') {
        this.panel = []
      }
      this.addDriverForms()
    },
    'formData.ownersMobileNumber': function (newVal, oldVal) {
      this.referenceId = ''
    }
  },
  methods: {
    handleTripsInput (index) {
      const value = this.formData.buses[index].tripsPerBus
      if (value > 5) {
        this.formData.buses[index].tripsPerBus = 5
        this.formData.buses[index].tripsError = true
      }
    },
    validateTrips (value) {
      return value <= 5 || 'Enter a number less than or equal to 5'
    },
    // preventInvalidInput (event) {
    //   const invalidChars = ['e', 'E', '-']
    //   if (invalidChars.includes(event.key)) {
    //     event.preventDefault()
    //   }
    // },
    preventInvalidInput (event) {
      const invalidChars = ['e', 'E', '-', '+', '.']
      if (invalidChars.includes(event.key)) {
        event.preventDefault()
        return
      }

      const allowedControlKeys = [
        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
      ]
      if (allowedControlKeys.includes(event.key)) {
        return
      }

      const index = event.target.dataset.index
      const bus = this.formData.buses[index]
      const currentValue = String(bus.tripsPerBus || '')

      // Allow typing only a single digit between 1 and 5
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault()
        return
      }

      const newValue = currentValue + event.key
      if (parseInt(newValue) > 5) {
        event.preventDefault()
      }
    },
    handleBackspace (event, value) {
      if (event.key === 'Backspace' && value.toString().length <= 1) {
        event.preventDefault()
      }
    },
    handleNumberInput (event, uniqueNumber) {

    },
    handleCancelForm () {
      let isDataInserted = false
      if (
        this.formData.franchiseeID ||
        this.formData.ownedBy ||
        this.formData.ownerName ||
        this.formData.ownersMobileNumber
      ) {
        isDataInserted = true
      }
      if (isDataInserted) {
        this.$buefy.dialog.confirm({
          message: 'All the entered data will be lost. Are you Sure you want to Cancel the process?',
          confirmText: 'Proceed Cancellation',
          cancelText: 'Not Now',
          onConfirm: () => {
            this.$router.push({ name: 'Vendor' })
          }
        })
      } else {
        this.$router.push({ name: 'Vendor' })
      }
    },
    handleCloseConfirmDialog () {

    },
    handleOpenConfirmDialog () {

    },
    handleVehicleHeaderClick () {
      if (!this.hasShownVehicleConfirmDialog) {
        let franchise = this.franchiseeArr.find(item => item.id === this.formData.franchiseeID)
        let msg = `Kindly note you will now be adding vehicles details for ${franchise.companyName}<br/> Are you sure you want to Proceed.`
        this.$buefy.dialog.confirm({
          message: msg,
          cancelText: 'Cancel',
          confirmText: 'Proceed',
          onConfirm: () => {
            this.hasShownVehicleConfirmDialog = true
          },
          onCancel: () => {
            this.panel = []
          }
        })
      }
    },
    handleValidateExpiryDate (event, key, type, fieldName, index) {
      let todayDate = moment().startOf('day')
      let inputDate = moment(event)
      let diffInDays = inputDate.diff(todayDate, 'days')
      if (diffInDays < 60) {
        this.errMsg(`The vehicle cannot be added, as the ${key} is expiring in 60 days. Please add vehicle with valid ${key}`)
        this.$set(this.formData[type][index], fieldName, null)
      }
    },
    formatVehicleNumber (input) {
      if (!input) return ''

      // remove everything except letters and digits, uppercase
      let raw = input.toUpperCase().replace(/[^A-Z0-9]/g, '')

      // pointers / limits
      const MAX_STATE = 2
      const MAX_RTO = 2
      const MAX_SERIES = 2
      const MAX_NUMBER = 4

      let pos = 0
      let formatted = ''

      // 1) state: MUST be letters and exactly 2 to proceed
      let state = raw.substring(pos, pos + MAX_STATE).replace(/[^A-Z]/g, '')
      pos += state.length
      formatted = state
      if (state.length < MAX_STATE) {
        // still typing state or invalid next char — don't allow anything else
        return formatted
      }

      // If we've got exactly two letters, the next char MUST be a digit (RTO)
      if (raw.length > pos && !/^\d$/.test(raw.charAt(pos))) {
        // user typed a non-digit after state — block it by returning state only
        return formatted
      }

      // 2) rto: digits (1-2)
      let rto = ''
      while (rto.length < MAX_RTO && pos < raw.length && /^\d$/.test(raw.charAt(pos))) {
        rto += raw.charAt(pos)
        pos++
      }
      if (rto) formatted += '-' + rto
      // If no rto digits provided yet, stop here (blocks letters)
      if (rto.length === 0) return formatted

      // After rto we require series letters next — if next char exists and is not letter, block
      if (raw.length > pos && !/^[A-Z]$/.test(raw.charAt(pos))) {
        return formatted
      }

      // 3) series: letters (1-2)
      let series = ''
      while (series.length < MAX_SERIES && pos < raw.length && /^[A-Z]$/.test(raw.charAt(pos))) {
        series += raw.charAt(pos)
        pos++
      }
      if (series) formatted += '-' + series
      if (series.length === 0) return formatted

      // After series we require number digits — if next char exists and is not digit, block
      if (raw.length > pos && !/^\d$/.test(raw.charAt(pos))) {
        return formatted
      }

      // 4) number: digits (1-4)
      let number = ''
      while (number.length < MAX_NUMBER && pos < raw.length && /^\d$/.test(raw.charAt(pos))) {
        number += raw.charAt(pos)
        pos++
      }
      if (number) formatted += '-' + number

      // final safety: maximum formatted length (MH-99-AA-9999 = 13 chars)
      if (formatted.length > 13) formatted = formatted.substring(0, 13)

      return formatted
    },
    handleVehicleNumberInput (value, index) {
      const formatted = this.formatVehicleNumber(value)
      // write back to model (this will update the field immediately)
      this.formData.buses[index].vehicleRegistrationNumber = formatted

      // validate and call uniqueness check only when pattern is complete
      if (this.rules.patternRule(formatted) === true) {
        this.checkVehicleNumberUniqueness(formatted, index)
      } else {
        // clear any previous validation error while typing
        this.$set(this.formData.buses[index], 'vehicleValidationError', '')
      }
    },
    handleVehicleNumberKeydown (ev, index) {
      const allowedControlKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
      ]
      if (allowedControlKeys.includes(ev.key)) return

      // if selection exists, allow (so user can replace selection)
      const target = ev.target || ev.srcElement
      const selectionLength = target && target.selectionEnd != null
        ? (target.selectionEnd - target.selectionStart)
        : 0

      // current formatted value
      const cur = this.formData.buses[index].vehicleRegistrationNumber || ''

      // max length of fully formatted string is 13 (MH-99-AA-9999)
      const MAX_FULL = 13

      // if already full and nothing selected to replace, block input
      if (cur.length >= MAX_FULL && selectionLength === 0) {
        ev.preventDefault()
      }

      // Additional fine-grained prevention is optional because formatVehicleNumber will sanitize,
      // but this keeps user from typing letters where only digits required etc.
      // Let the formatter handle it — no more strict checks here
    },
    // handle paste: format pasted text and prevent raw paste
    handleVehicleNumberPaste (ev, index) {
      ev.preventDefault()
      const pasted = (ev.clipboardData || window.clipboardData).getData('text') || ''
      const formatted = this.formatVehicleNumber(pasted)
      this.formData.buses[index].vehicleRegistrationNumber = formatted

      // run uniqueness check if complete
      if (this.rules.patternRule(formatted) === true) {
        this.checkVehicleNumberUniqueness(formatted, index)
      } else {
        this.$set(this.formData.buses[index], 'vehicleValidationError', '')
      }
    },
    async checkVehicleNumberUniqueness (vehicleNumber, index) {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const { data } = await http.get(
          `${constants.API_URL}/api/transport/vendors/checkVehicleUniqueness`,
          { params: { vehicleNumber } } // pass number in query
        )

        if (data.exists) {
          this.$set(
            this.formData.buses[index],
            'vehicleValidationError',
            'This vehicle registration number is already assigned to an active bus. Please deactivate the existing bus before adding a new one.'
          )
        } else {
          this.$set(this.formData.buses[index], 'vehicleValidationError', '')
        }
      } catch (error) {
        console.error('Error fetching active bus numbers:', error)
      } finally {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    handleRemoveVehicleCard (index) {
      this.$buefy.dialog.confirm({
        message: 'All the entered data will be lost. Are you Sure you want to Cancel the process?',
        cancelText: 'Not Now',
        confirmText: 'Proceed Cancellation',
        onConfirm: () => {
          let vehicleCount = Number(this.formData.numberOfVehicle)
          this.formData.buses.splice(index, 1)
          this.formData.numberOfVehicle = vehicleCount - 1
        }
      })
    },
    handleRemoveDriverCard (index) {
      this.$buefy.dialog.confirm({
        message: 'All the entered data will be lost. Are you Sure you want to Cancel the process?',
        cancelText: 'Not Now',
        confirmText: 'Proceed Cancellation',
        onConfirm: () => {
          let driverCount = Number(this.formData.numberOfDrivers)
          this.formData.drivers.splice(index, 1)
          this.formData.numberOfDrivers = driverCount - 1
        }
      })
    },
    handleAddVehicleDetails () {
    },
    handleAddDriverDetails () {

    },
    toggleExpand () {
      this.isExpanded = !this.isExpanded // Toggle the state
    },

    getDateAfterNDays (date, n) {
      return moment(date).add(20, 'd').format('YYYY-MM-DD')
    },
    getTodayDate () {
      return moment().format('YYYY-MM-DD')
    },
    setFocusedInput (event, index) {
      this.focusedBus = index
    },
    clearFocusedInput () {
      this.focusedBus = null
    },

    addBusForms () {
      const busesCount = this.formData.numberOfVehicle
      const newBuses = []
      for (let i = 0; i < busesCount; i++) {
        let bus = this.formData.buses[i]

        let busData = bus || this.getBusFields()
        newBuses.push(busData)
      }
      this.formData.buses = newBuses
    },
    increaseDriversCount () {
      let driverCount = Number(this.formData.numberOfDrivers)
      this.formData.numberOfDrivers = driverCount + 1
    },
    increaseVehicleCount () {
      let vehicleCount = Number(this.formData.numberOfVehicle)
      this.formData.numberOfVehicle = vehicleCount + 1
    },
    addDriverForms () {
      const driverCount = this.formData.numberOfDrivers
      const newDrivers = []
      for (let i = 0; i < driverCount; i++) {
        let driver = this.formData.drivers[i]
        let driverData = driver || this.getDriverFields()
        newDrivers.push(driverData)
      }
      this.formData.drivers = newDrivers
    },
    getBusFields () {
      return {
        isCCTVInstalled: false,
        vehicleRegistrationNumber: '',
        seatingCapacity: '',
        makeOfVehicle: '',
        modelOfVehicle: '',
        rcBookExpiryDate: '',
        pucExpiryDate: '',
        rcBookFrontPhoto: null,
        rcBookBackPhoto: null,
        pucFrontPhoto: null,
        vehicleFrontViewPhoto: null,
        vehicleRearViewPhoto: null,
        vehicleInteriorViewPhoto: null,
        vehicleInteriorLeftViewPhoto: null,
        vehicleInteriorRightViewPhoto: null,
        rcBookFrontPhotoUrl: null,
        rcBookBackPhotoUrl: null,
        pucFrontPhotoUrl: null,
        vehicleFrontViewPhotoUrl: null,
        vehicleRearViewPhotoUrl: null,
        vehicleInteriorViewPhotoUrl: null,
        vehicleInteriorLeftViewPhotoUrl: null,
        vehicleInteriorRightViewPhotoUrl: null
      }
    },
    getDriverFields () {
      return {
        showVerificationDriver: false,
        isMobileNoVerifiedDriver: false,
        driverName: '',
        driverMobileNumber: '',
        driverLicenseNumber: '',
        uniqueIdentificationNumber: '',
        licenceExpiryDate: '',
        driverLicenseFrontPhoto: null,
        driverPhoto: null,
        driverPoliceVerificationPhoto: null,
        driverLicenseFrontPhotoUrl: null,
        driverPhotoUrl: null,
        driverPoliceVerificationPhotoUrl: null
      }
    },
    isBusFormAllFilled (index) {
      let isAllFilled = true
      let bus = this.formData.buses[index]
      for (let key in bus) {
        if (!key.includes('Photo') &&
          !bus[key] &&
          !['isFormDrafted', 'shouldDraftButtonDisable', 'isBusFocused'].includes(key)
        ) {
          isAllFilled = false
          bus.shouldDraftButtonDisable = false
          break
        }
      }
      return isAllFilled
    },
    areUniqueBusInputs () {
      let s = new Set()
      for (let bus of this.formData.buses) {
        let veh = bus.vehicleRegistrationNumber.toLowerCase().split('').filter(i => i !== ' ').join('')
        if (s.has(veh)) {
          return false
        }
        s.add(veh)
      }
      return true
    },
    isBusDocumentsSelected (index) {
      let bus = this.formData.buses[index]
      for (let key of this.fileKeys) {
        if (!bus[key] || (bus[key] && !(bus[key] instanceof File))) {
          return false
        }
      }
      return true
    },
    async verifyOtp (field, fieldData, index, driverFieldData) {
      // Owner Mobile Verification
      if (field === 'owner') {
        if (fieldData === 'up') {
          // remove this later
          // this.isMobileNoVerified = true
          // if (this.isMobileNoVerified) return
          // upto here
          this.referenceId = ''
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.otp = ''
        }
        if (!this.interval) {
          this.timer = 60
          this.startTimer()
        }
        this.showVerification = true
        await this.verifyMobileNo(this.formData.ownersMobileNumber)
        if (this.verifiedFlag) {
          this.isMobileNoVerified = true
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.isTimerEnded = false
          this.timer = 60
          this.verifiedFlag = false
          this.showVerification = false
        }
      } else if (field === 'ownerResend') {
        await this.resendCode(this.formData.ownersMobileNumber)
        this.timer = 60
        this.isTimerEnded = false
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        this.startTimer()
      }
      // Driver Mobile Verification
      if (field === 'driver') {
        if (driverFieldData === 'up') {
          this.referenceId = ''
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.otp = ''
        }
        if (!this.interval) {
          this.timer = 60
          this.startTimer()
        }
        this.formData.drivers[index].isMobileNoVerifiedDriver = false
        this.formData.drivers[index].showVerificationDriver = true
        await this.verifyMobileNo(fieldData.driverMobileNumber)
        if (this.verifiedFlag) {
          this.formData.drivers[index].isMobileNoVerifiedDriver = true
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.isTimerEnded = false
          this.timer = 60
          this.formData.drivers[index].showVerificationDriver = false
          this.verifiedFlag = false
        }
      } else if (field === 'driverResend') {
        await this.resendCode(fieldData.driverMobileNumber)
        this.timer = 60
        this.isTimerEnded = false
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        this.startTimer()
      }
    },
    async verifyMobileNo (mobileNo) {
      let apiResult = null
      if (!this.referenceId) {
        const payload = {
          'referenceId': null,
          'otpClient': null,
          'mobileNo': mobileNo,
          'resendCount': '0'
        }
        apiResult = await http.post(
          `${constants.API_URL}/api/admin/verifyotp`,
          payload
        )
        if (apiResult?.data?.isSent) {
          this.referenceId = apiResult.data.referenceId
        }
      } else {
        const payload = {
          'referenceId': this.referenceId,
          'otpClient': this.otp,
          'mobileNo': mobileNo,
          'resendCount': '0'
        }
        apiResult = await http.post(
          `${constants.API_URL}/api/admin/verifyotp`,
          payload
        )
        if (apiResult?.data?.isVerified) {
          this.verifiedFlag = true
          this.referenceId = ''
          this.otp = ''
          return this.$buefy.toast.open({
            message: 'Verified',
            type: 'is-success',
            duration: 3000
          })
        } else if (apiResult?.data?.isVerified === false) {
          return this.$buefy.toast.open({
            message: 'Wrong OTP. Try Again!',
            type: 'is-danger',
            duration: 3000
          })
        }
      }
    },
    startTimer () {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.interval = null
          this.isTimerEnded = true
        } else {
          this.timer--
        }
      }, 1000)
    },
    async resendCode (mobileNo) {
      this.otp = ''
      const payload = {
        'referenceId': this.referenceId,
        'otpClient': '',
        'mobileNo': mobileNo,
        'resendCount': '1'
      }
      const apiResult = await http.post(
        `${constants.API_URL}/api/admin/verifyotp`,
        payload
      )
      if (apiResult?.data?.isSent) {
        this.referenceId = apiResult.data.referenceId
      }
    },
    validVendorDetails () {
      if (!this.formData.franchiseeID ||
          !this.formData.ownedBy ||
          !this.formData.ownerName ||
          !this.formData.ownersMobileNumber ||
          !this.formData.numberOfVehicle ||
          !this.formData.numberOfDrivers
      ) {
        return false
      }
      if (!this.isMobileNoVerified) {
        return false
      }
      if (this.formData.numberOfVehicle < 1 || this.formData.numberOfDrivers < 1) {
        return false
      }
      return true
    },
    validVehicleDetails () {
      let buscount = this.formData.buses.length
      if (buscount === 0) {
        return false
      }
      let vehicleKeyFields = Object.keys(this.getBusFields())

      for (let i = 0; i < buscount; i++) {
        let vehicle = this.formData.buses[i]

        // Block if bus has any validation errors
        if (vehicle.vehicleValidationError && vehicle.vehicleValidationError.length > 0) {
          return false
        }
        // Validate tripsPerBus explicitly
        const trips = Number(vehicle.tripsPerBus)
        if (!trips || isNaN(trips) || trips < 1 || trips > 5) {
          return false
        }
        for (let key of vehicleKeyFields) {
          if (key === 'isCCTVInstalled' && vehicle[key] === false) {
            return false
          }
          if (key === 'vehicleRegistrationNumber') {
            console.log('pattern test')
            const value = vehicle['vehicleRegistrationNumber']
            const pattern = /^[A-Z]{2}-\d{2}-[A-Z]{2}-\d{4}$/
            if (!pattern.test(value)) {
              return false
            }
          }
          if (!vehicle[key]) {
            return false
          }
          if (vehicle.gpsWorking !== 'yes' && vehicle.gpsWorking !== 'no') {
            return false
          }
        }
      }
      if (this.formData.numberOfVehicle < 1 || this.formData.numberOfDrivers < 1) {
        return false
      }
      this.isVehicleDetailsPresent = true
      return true
    },
    validDriverDetails () {
      let driversCount = this.formData.drivers.length
      if (driversCount === 0) {
        return false
      }
      let driverFieldKeys = Object.keys(this.getDriverFields())
      for (let i = 0; i < driversCount; i++) {
        let driver = this.formData.drivers[i]
        for (let key of driverFieldKeys) {
          if (key === 'isMobileNoVerifiedDriver' && !driver[key]) {
            return false
          }
          if (key === 'uniqueIdentificationNumber' && driver[key].length !== 12) {
            return false
          }
          if (key === 'showVerificationDriver' || key === 'isMobileNoVerifiedDriver') {
            continue
          }
          if (!driver[key]) {
            return false
          }
          if (key === 'uniqueIdentificationNumber') {
            if (!driver[key] || driver[key].length !== 12) {
              return false
            }
          }
        }
      }
      return true
    },
    validateForm () {
      // if (!this.formData.academicYearID || !this.formData.franchiseeID || !this.formData.numberOfVehicle) {
      //   return false
      // }
      if (!this.validVendorDetails()) {
        return false
      }
      if (!this.validVehicleDetails()) {
        return false
      }
      if (!this.validDriverDetails()) {
        return false
      }

      if (!this.areUniqueBusInputs()) {
        this.errMsg('Vehicle Registration number inputs must be unique')
        return false
      }
      return true
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`
        )
        this.academicYears = data.rows

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
      }
    },
    deleteDropFile (data, key) {
      this.$set(data, key, null)
      let urlKey = key.replace('Photo', 'PhotoUrl')
      this.$set(data, urlKey, null)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
        if (this.franchiseeArr.length === 1) {
          this.formData.franchiseeID = this.franchiseeArr[0].id
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        this.$buefy.dialog.confirm({
          title: 'Vendor Addition Confirmation',
          message: `Are you sure you want to proceed.<br/> The details once added won't be deleted but can only be deactivated.`,
          cancelText: 'No',
          confirmText: 'Yes',
          type: 'is-success',

          onConfirm: async () => {
            try {
              for (let driver of this.formData.drivers) {
                if (!driver.isMobileNoVerifiedDriver) {
                  this.loadingComponent.close()
                  this.errMsg('All Drivers mobile No. should be verified!')
                  return
                }
              }

              const fieldsToRemove = [
                'showVerificationDriver',
                'isMobileNoVerifiedDriver'
              ]

              // Clean buses
              let buses = this.formData.buses.map((bus, index) => {
                let updatedBus = {
                  ...bus,
                  busSequenceNumber: index + 1
                }

                delete updatedBus.isCCTVInstalled
                delete updatedBus.isBusFocused
                delete updatedBus.isFormDrafted
                delete updatedBus.shouldDraftButtonDisable

                // Remove photo and URL fields
                for (let key in updatedBus) {
                  if (key.includes('Photo') || key.includes('PhotoUrl')) { delete updatedBus[key] }
                }

                return updatedBus
              })

              // Clean drivers
              let drivers = this.formData.drivers.map((driver, index) => {
                let updatedDriver = {
                  ...driver,
                  driverSequenceNumber: index + 1
                }

                for (let key in updatedDriver) {
                  if (key.includes('Photo')) { delete updatedDriver[key] }
                }

                fieldsToRemove.forEach(f => delete updatedDriver[f])

                return updatedDriver
              })

              const formData = new FormData()

              // Add vendor master as JSON
              formData.append('franchiseeID', this.formData.franchiseeID)
              formData.append('ownedBy', this.formData.ownedBy) // map correctly
              formData.append('ownerName', this.formData.ownerName)
              formData.append('ownersMobileNumber', this.formData.ownersMobileNumber)
              formData.append('numberOfVehicle', this.formData.numberOfVehicle)
              formData.append('numberOfDrivers', this.formData.drivers.length)

              formData.append('buses', JSON.stringify(buses))
              formData.append('drivers', JSON.stringify(drivers))

              formData.append('busMetaData', JSON.stringify(this.fileFields))
              formData.append('driverMetaData', JSON.stringify(this.driverfileFields))

              this.formData.buses.forEach((bus, index) => {
                for (let field of this.fileFields) {
                  formData.append(
                    `busDoc_${field.field}_${index + 1}`,
                    bus[field.field]
                  )
                }
              })

              this.formData.drivers.forEach((driver, index) => {
                for (let field of this.driverfileFields) {
                  formData.append(
                    `driverDoc_${field.field}_${index + 1}`,
                    driver[field.field]
                  )
                }
              })

              this.hasClicked = true

              await http.post(
                `${constants.API_URL}/api/transport/vendors/create-with-documents`,
                formData
              )

              this.clearDraft()
              this.loader = false
              this.$router.push({ name: 'Vendor' })
            } catch (e) {
              this.loadingComponent.close()
              const errorMessage =
                (e && e.response && e.response.data.message) || e.message
              this.lock = false
              this.hasClicked = false
              this.loader = false

              return this.$buefy.dialog.alert({
                message: errorMessage,
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: 'mdi-exclamation',
                iconPack: 'mdi'
              })
            } finally {
              this.loadingComponent.close()
            }
          }
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.loader = false

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: 'mdi-exclamation',
          iconPack: 'mdi'
        })
      }
    },
    onFileChange (bus, key, filetype, index) {
      const file = event.target.files[0]

      let isValidFile = true
      if (!this.allowedExtensions.includes(file.type)) {
        this.$buefy.dialog.alert({
          message: 'Allowed file type will be jpg, jpeg, png, heic, heif',
          type: 'is-danger',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        isValidFile = false
        return
      }
      if (file.size > this.maxFileSize) {
        this.$buefy.dialog.alert({
          message: 'Allowed Max 2 MB file size',
          type: 'is-danger',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        isValidFile = false
        return
      }
      if (isValidFile) {
        this.$set(bus, key, file)
        let urlKey = `${key}Url`
        if (filetype === 'fileFields') {
          let url = URL.createObjectURL(file)
          this.$set(bus, urlKey, url)
        }
        if (filetype === 'driverfileFields') {
          let url = URL.createObjectURL(file)
          this.$set(bus, urlKey, url)
        }
      }
    },
    draftBusDetails (index) {
      const bus = this.formData.buses[index]
      this.$set(bus, 'isFormDrafted', true)
      this.focusedBus = null
      if (this.isBusFormAllFilled(index)) {
        this.$set(bus, 'shouldDraftButtonDisable', true)
      }
      this.clearDraft()

      localStorage.setItem('vendorDraft', JSON.stringify(this.formData))
      this.$dialog.message.info(`Bus - ${index + 1} Drafted successfully!`, {
        position: 'bottom-right',
        color: 'secondary',
        timeout: 4000
      })
    },
    loadDraft () {
      const savedDraft = JSON.parse(localStorage.getItem('vendorDraft'))
      if (savedDraft) {
        this.formData = savedDraft
        this.formData.buses = this.formData.buses.map((bus, index) => {
          bus.driverPhoto = ''
          bus.busFrontViewPhoto = ''
          bus.busSideViewPhoto = ''
          bus.busRearViewPhoto = ''
          bus.busInteriorViewPhoto = ''
          bus.rcBookPhoto = ''
          if (bus.isFormDrafted) {
            return bus || this.getBusFields()
          }
        })
      }
    },
    clearDraft () {
      localStorage.removeItem('vendorDraft')
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
.blue-header {
  background-color: #1a86df;
  color: white;
  font-weight: bold;
}

.light-blue-header {
  background-color: #a7d7ff;
  color: white;
  font-weight: bold;
}

.heading-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-heading, .right-heading {
  margin: 0;
  font-weight: bold;
}
.no-spinner input::-webkit-outer-spin-button,
.no-spinner input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.vendarodetailsborder{
  box-shadow: none!important;
  border: 1px solid #ccc!important;
}
.vendarodetailsborder02{
  box-shadow: none!important;
  border: none;
}
.vendarodetailsborderpadd{
  padding: 0px;
}
.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #fff;
}
.relative-position{
  padding: 15px;
    box-shadow: none !important;
    border: 1px solid #ccc !important;
}
.upload.control.file-label{
 overflow: unset;
 margin: 0px auto;
}
.vendarodetailsborderpadd01 .v-expansion-panel-content__wrap{
  padding: 0px;
}
.container{
  padding: 12px 2px;
}
.vendarodetailsborderpadd .v-expansion-panel-content__wrap{
  padding: 0 0px 16px;
}
.carduploadview{
  box-shadow: none;
  border: 1px solid #ccc;
  padding: 15px;
}
.carduploadviewnone{
  border: none!important;
}
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgb(0 0 0 / 38%);
}
.mobile-field {
  position: relative
}
.verify-cta {
  position: absolute;
  right: 0
}
.fullwidthmainsection{
  max-width: 100%;
}
.italic-hint .v-messages__message {
  font-style: italic;
}
</style>
